import axios from "./axios";

export const postDonation = donation => axios.get().post(`/donation`, donation)
export const getDonationPayment = paymentId => axios.get().get(`/donation/${paymentId}`);
